export default {
  RETURN_COST: 1,
  PETTY_CASH_CHARGE: 2,
};

export const ReceiveTitle = {
  1: "برگشت خرید یا هزینه",
  2: "شارژ تنخواه",
};
